export default __webpack_public_path__ + "static/media/home-brandfont.d043fb53.svg";